"use client";

import { SbCookieDeclaration } from "@storyblok/types/287435740670216/storyblok-components";

export function CookieDeclarationComponent({
  blok,
  pageData,
}: {
  blok: SbCookieDeclaration;
  pageData: { locale: string };
}) {
  return (
    <>
      <div
        className="my-4"
        id="cookie-declaration-script"
        dangerouslySetInnerHTML={{
          __html: `<script src="https://consent.cookiebot.com/${blok.domainGroupId}/cd.js" data-culture="${pageData?.locale ?? "nl"}" type="text/javascript" async></script>`,
        }}
      />
    </>
  );
}
